<template>
  <nav class="navbar navbar-expand-md navbar-light
    border-bottom align-items-center fixed-top bg-white">
    <a href="#" v-if="loginStatus" class="h2 mb-0 mr-3" @click.prevent="toggleModal">
      <span class="material-icons fa-times"> clear </span>
      <span class="material-icons fa-bars"> menu </span>
    </a>
    <a class="navbar-brand mx-md-0 mx-auto" href="/dashboard">商業思維學院</a>
    <a v-if="postRouter == 'true'" class="mr-0 d-md-none d-inline-block"
      href="#" @click.prevent="toggleSideBarMobile">
      <span class="material-icons fa-video-library"> video_library </span>
      <span class="material-icons fa-video-times"> clear </span>
    </a>
    <a v-if="!loginStatus" class="nav-link ml-auto" href="/login">登入</a>
    <a v-if="!loginStatus" class="nav-link mr-0" href="/register">註冊</a>
  </nav>
</template>
<script>
export default {
  name: 'Navbar',
  props: {
    loginStatus: String,
    postRouter: String,
  },
  data() {
    return {
      openModal: false,
      openSidebar: false,
      changeCourseStatus: {
        prev: true,
        next: true,
      },
    };
  },
  methods: {
    changeCourse(behavior) {
      this.$bus.$emit('changeCourse', behavior);
    },
    toggleModal() {
      this.openModal = !this.openModal;
      this.$bus.$emit('openPersonalModal', this.openModal);
      this.openSidebar = false;
      this.$bus.$emit('openSidebar', false);
    },
    toggleSideBarMobile() {
      if (!this.openSidebar) {
        this.gaTrackEvent('Lesson', 'Click Course Menu', ''); // GA Event
      }
      this.openSidebar = !this.openSidebar;
      this.$bus.$emit('openSidebar', this.openSidebar);
      this.openModal = false;
      this.$bus.$emit('openPersonalModal', false);
    },
  },
  mounted() {
    const vm = this;
    this.$bus.$on('closeBar', (data) => {
      vm[data.param] = data.status;
    });
    this.$bus.$on('changeCourseStatus', (data) => {
      vm.changeCourseStatus = data;
    });
  },
};
</script>
<style scoped>
  .fa-times, .fa-video-times {
    display: none;
  }
  .fa-bars {
    display: inline-block;
  }
  .modal-open .fa-times {
    display: inline-block;
  }
  .modal-open .fa-bars {
    display: none;
  }
  .sidebar-open .fa-video-times {
    display: inline-block;
  }
  .sidebar-open .fa-video-library {
    display: inline-block;
    display: none;
  }
@media screen and (max-width: 768px) {
  .course-next-back {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    background: white;
  }
  .btn-custom-md {
    width: 100%;
    border-radius: 0px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    justify-content: center;
    border-left: 0px;
    border-right: 0px;
  }
}
</style>
